<template>
  <!--自定义消息提示-->
  <transition :name="fadeIn">
    <div class="message" v-show="show">
      <!-- 操作弹框 -->
      <div class="dialog" :class="setDialogBg">
        <div class="content">
          <i :class="setIconClass"></i>
          <span>{{text}}</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Message',
  data() {
    return {
      // 默认显示持续时间（毫秒）
      duration: 3000,
      show: false,
      // 默认图标（类名）
      iconClass: 'el-icon-info',
      type: 'success',
      timer: null,
      text: '',
    };
  },
  computed: {
    setIconClass() {
      return `el-icon-${this.type}`;
    },
    setDialogBg() {
      return `dialog-${this.type}`;
    },
    fadeIn() {
      return 'fadeIn';
    },
  },
  watch: {
    show(newVal, oldVal) {
      if (this.show) {
        setTimeout(() => {
          this.show = false;
        }, this.duration);
      }
    },
  },
};
</script>
<style scope>
.message{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  display: table;
  z-index: 9999;
  /* 穿透点击*/
  pointer-events: none
}
.dialog{
  position: absolute;
  min-width: 230px;
  display: table-cell;
  vertical-align: middle;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  overflow: hidden;
  margin: auto;
  z-index: 999;
  padding: 15px;
  border-radius: 4px;
  border-width: 1px;
  font-size: 22px
}
.dialog-success{
  background: rgba(103, 194, 58, .4);
  color: rgb(103, 194, 58)
}
.dialog-warning{
  background: rgba(230, 162, 60, .4);
  color: rgb(230, 162, 60)
}
.dialog-error{
  background: rgba(245, 108, 108, .4);
  color: rgb(245, 108, 108)
}
.dialog-info{
  background: rgba(144, 147, 153, .4);
  color: rgb(144, 147, 153)
}
.content{
  display: flex;
  flex-direction: row;
  text-align: center;
  margin: 15px
}
.content > i{
  margin: auto 5px
}
.content > span{
  letter-spacing: 2px
}
.fadeIn-enter-active, .fadeIn-leave-active{
  transition: opacity .7s
}
.fadeIn-enter, .fadeIn-leave-to{
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/assets/plugin/message/Message.vue